export const _en = {
    translation: {
        notFound: "Translation not found for: '{{path}}'"
    },
    timeline: {
        differentResourceTypes: {
            dialog: {
                title: "Error: resource types are different",
                body: "<p>You cannot move a task from a resource of type <b>{{oldResourceType}}</b> to a resource of type <b>{{newResourceType}}</b>.</p>"
            }
        }
    },
    resourceSkill: {
        skillLevel: {
            modal: {
                header: "Error: Skill levels not filled in",
                body: "Please fill in the <a href='#refSkillLevels'>skill level referential</a>"
            }
        },
        skill: {
            modal: {
                header: "Error: Skills not filled in",
                body: "Please fill in the <a href='#refSkills'>skill referential</a>"
            }
        },
        resource: {
            modal: {
                header: "Error: Resources not filled in",
                body: "Please fill in the <a href='#ressources'>resources referential</a>"
            }
        }
    },
    deletionConflict: {
        title: "",
        body: ""
    }
};

export const _fr = {
    translation: {
        notFound: "Traduction introuvable pour : '{{path}}'"
    },
    timeline: {
        differentResourceTypes: {
            dialog: {
                title: "Erreur : Ressources de types différents",
                body: "<p>Vous ne pouvez pas déplacer une activité depuis une ressource de type <b>{{oldResourceType}}</b> vers une ressource de type <b>{{newResourceType}}</b>.</p>"
            }
        },
        differentResourceCategories: {
            dialog: {
                title: "Erreur : Catégorie de ressources différentes",
                body: "<p>Vous ne pouvez pas déplacer une activité depuis une ressource de catégorie <b>{{oldResourceCategory}}</b> vers une ressource de catégorie <b>{{newResourceCategory}}</b>.</p>"
            }
        },
        resourceAlreadyHaveActivity: {
            dialog: {
                title: "Erreur : Ressource en doublon sur l'activité",
                body: "<p>Une ressource ne peut pas être affectée 2 fois sur la même activité.</p>"
            }
        }
    },
    resourceSkill: {
        skillLevel: {
            modal: {
                header: "Erreur : Niveaux de compétences absents",
                body: "Veuillez renseigner le <a href='#refSkillLevels'>référentiel des niveaux de compétences</a>."
            }
        },
        skill: {
            modal: {
                header: "Erreur : Compétences absentes",
                body: "Veuillez renseigner le <a href='#refSkills'>référentiel des compétences</a>."
            }
        },
        resource: {
            modal: {
                header: "Erreur : Ressources absentes",
                body: "Veuillez renseigner le <a href='#ressources'>référentiel des ressources</a>."
            }
        }
    },
    deletionConflict: {
        title: "Conflit de suppression",
        body: "L'élément que vous voulez supprimer est utilisé ailleurs dans l'application"
    }
};